import React, { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import { TextField } from 'next-common-lib';
import i18n from 'i18n';
import { checkKoreaNationCode } from 'utils/common';
import DropDownTelCode from 'components/IncorporationOfTerms/Register/FormAtoms/DropDownTelCode';

const PhoneNumberHookForm = ({ type, name, disabled, values }) => {
  const { setValue, getValues } = useFormContext();
  let initialValues = getValues(`'${name}'`);
  const nationTelCode = useWatch({ name: `nationTelCode` });
  const [nationCode, setNationCode] = useState(null);
  const [subNumber1, setSubNumber1] = useState(null);
  const [subNumber2, setSubNumber2] = useState(null);
  const [subNumber3, setSubNumber3] = useState(null);

  const regexNumber = /^[0-9]+$/;

  const setTelValue = () => {
    const DASH = '-';
    let val = nationTelCode;

    if (subNumber1 && subNumber1.length > 0) {
      val += DASH + subNumber1.replace(/^0+/, '');
    }

    if (checkKoreaNationCode(nationTelCode)) {
      if (subNumber2 && subNumber2.length > 0) {
        val += DASH + subNumber2;
      }
      if (subNumber3 && subNumber3.length > 0) {
        val += DASH + subNumber3;
      }
    }

    if (val === nationTelCode) return '';
    return val;
  };
  const clearTelNo = () => {
    setSubNumber1(null);
    setSubNumber2(null);
    setSubNumber3(null);
  };

  useEffect(() => {
    setValue(name, setTelValue());
  }, [nationTelCode, subNumber1, subNumber2, subNumber3]);

  useEffect(() => {
    if (!disabled && values.length > 0) {
      initialValues = values.includes(',') ? values.substr(0, values.indexOf(',')) : values;
      const initialValuesArr = initialValues.length > 0 ? initialValues.split('-') : [];
      setNationCode(initialValuesArr[0] || null);
      setSubNumber1(initialValuesArr[1] || null);
      setSubNumber2(initialValuesArr[2] || null);
      setSubNumber3(initialValuesArr[3] || null);
    }
  }, [values, disabled]);

  return (
    <>
      <DropDownTelCode name="nationTelCode" disabled={disabled} initValue={nationCode} selectCallBack={clearTelNo} />
      <span className="gab">-</span>
      {nationTelCode === '+82' ? (
        <>
          <TextField
            className="w-100"
            useExpLabel={false}
            id={subNumber1}
            label={subNumber1}
            value={subNumber1}
            maxLength={4}
            disabled={disabled}
            onChange={e => setSubNumber1(e.target.value)}
            onRestrict={labelVal => {
              return (labelVal && regexNumber.test(labelVal)) || labelVal.length === 0;
            }}
            onDelete={() => {
              setValue(subNumber1, '');
              setSubNumber1('');
            }}
          />
          <div className="gab">-</div>
          <TextField
            className="w-100"
            useExpLabel={false}
            id={subNumber2}
            label={subNumber2}
            value={subNumber2}
            maxLength={4}
            disabled={disabled}
            onChange={e => setSubNumber2(e.target.value)}
            onRestrict={labelVal => {
              return (labelVal && regexNumber.test(labelVal)) || labelVal.length === 0;
            }}
            onDelete={() => {
              setValue(subNumber2, '');
              setSubNumber2('');
            }}
          />
          <div className="gab">-</div>
          <TextField
            className="w-100"
            useExpLabel={false}
            id={subNumber3}
            label={subNumber3}
            value={subNumber3}
            maxLength={4}
            disabled={disabled}
            onChange={e => setSubNumber3(e.target.value)}
            onRestrict={labelVal => {
              return (labelVal && regexNumber.test(labelVal)) || labelVal.length === 0;
            }}
            onDelete={() => {
              setValue(subNumber3, '');
              setSubNumber3('');
            }}
          />
        </>
      ) : (
        <TextField
          className="type-full"
          useExpLabel={false}
          id={subNumber1}
          label={subNumber1}
          value={subNumber1}
          maxLength={50}
          disabled={disabled}
          placeholderLabel={i18n.t('MB_T_PHONE_HOLDER')}
          onChange={e => setSubNumber1(e.target.value)}
          onRestrict={labelVal => {
            return (labelVal && regexNumber.test(labelVal)) || labelVal.length === 0;
          }}
          onDelete={() => {
            setValue(subNumber1, '');
            setSubNumber1('');
          }}
        />
      )}
    </>
  );
};
PhoneNumberHookForm.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  values: PropTypes.string,
};
PhoneNumberHookForm.defaultProps = {
  disabled: false,
  type: '',
  values: '',
};
export default PhoneNumberHookForm;
